module.exports = __webpack_public_path__ + "img/lock.bdec09c4.png";